<template>
	<div class="back-button-container">
		<a href="/?back" tabindex="0" aria-label="go to previous screen" @click.prevent="back">
			<BaseIcon v-if="showIcon"
				icon="backChevron"
				class="size--modular"
				:isCustom="true"
				size="lg"/>
			<span>{{ useTitle }}</span>
		</a>
	</div>
</template>

<script>
	import navigationMixin from '@Mixin/navigationMixin';
	import EventBus from '@EventBus';
    export default {
		mixins: [navigationMixin],
        props: {
            title: {
                type: String,
                default: '',
            },
            route: {
                type: String,
				default: null,
            },
            click: {
                type: Function,
                default: null,
            },
            showIcon: {
                type: Boolean,
                default: true,
            }
		},
		computed: {
			useTitle() {
				if (this.$isMobile) {
					return '';
				}
				return this.title;
			}
		},
		methods: {
			defaultBackAction() {
				const router = this.$router;
				if (this.route) {
					if (this.route.includes('*')) {
						const useRoute = this.route.replace('*','');
						router.push({ name: useRoute });
						return;
					}
					router.push({ path: this.route });
					return;
				}
				this._navigateBack();
			},
			back() {
				if (!this.click) {
					this.defaultBackAction();
					return;
				}
				const resolved = this.click();
				if (typeof resolved === 'undefined') {
					return;
				}
				if (!resolved) {
					this.defaultBackAction();
				}
			},
		},
	}
</script>

<style lang="scss" scoped>
	@import 'globalStyles';
	a {
		display: flex;
		align-items: center;
		color: $storeButtonColor;
	}

	span {
		margin-left: 0.4em;

		font-weight: bold;
	}
	@include mobile {
		.back-button-container {
			display: flex;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/common/BaseBackButton.vue